"use strict";
// Cross-workspace validation primitives. Single source of truth for the field
// formats and limits that the frontend forms (AntD rules), the backend Zod
// schemas, and the hub drawers all need to agree on.
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPhoneFr = exports.emailMatchPattern = exports.normalizeEmail = exports.isEmail = exports.PASSWORD_MIN_LENGTH = exports.PHONE_FR_RE = exports.EMAIL_RE = void 0;
// Canonical email pattern. Anchored, rejects whitespace, requires a dot in the
// domain — used by every email field across the app (auth, clients, salesmen,
// companies) so validation never diverges per form.
exports.EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
// French landline/mobile format: leading 0 then 9 digits (e.g. 0612345678).
exports.PHONE_FR_RE = /^0[1-9]\d{8}$/;
// Minimum password length enforced on every password set/reset entry point.
exports.PASSWORD_MIN_LENGTH = 8;
const isEmail = (value) => typeof value === 'string' && exports.EMAIL_RE.test(value);
exports.isEmail = isEmail;
// A sign-in address is written lowercased and trimmed, and looked up without
// regard to case: « Contact@Societe.fr » and « contact@societe.fr » are the same
// account. Addresses stored before this rule keep their case (no data
// migration), so every lookup goes through `emailMatchPattern`, never `_eq`.
const normalizeEmail = (value) => value.trim().toLowerCase();
exports.normalizeEmail = normalizeEmail;
// Hasura `_ilike` pattern matching exactly this address, whatever its case.
// `_` and `%` are LIKE wildcards and `_` is common in addresses, so both are
// escaped (backslash is LIKE's default escape character).
const emailMatchPattern = (value) => (0, exports.normalizeEmail)(value).replace(/[\\%_]/g, (c) => `\\${c}`);
exports.emailMatchPattern = emailMatchPattern;
const isPhoneFr = (value) => typeof value === 'string' && exports.PHONE_FR_RE.test(value);
exports.isPhoneFr = isPhoneFr;
//# sourceMappingURL=index.js.map